var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#000"}},[_c('div',{staticClass:"box_one",staticStyle:{"margin-bottom":"5px"}},[_c('cont-top')],1),_c('router-view'),_c('div',{staticClass:"box_bottom"},[_c('cont-bottom')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }